import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import { useSelector } from 'react-redux'

const DownloadFile = () => {
  const { fileName } = useSelector((state) => state.download)
  return (
    <>
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        gap: "10px",
        right: "10px",
        bottom: "10px",
        borderRadius: "10px",
        padding: "10px",
      }}>
        {fileName?.map((item) => (
          <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: '10px',
            backgroundColor: "white",
            border: "1px solid rgb(184, 184, 184)",
            borderRadius: '10px',
            justifyContent: "space-around",
          }}>
            <CircularProgress size={20} />
            <Typography sx={{
              textAlign: "center"
            }}>{`Downloading ${item}`}</Typography>
          </Box>
        ))}
      </Box>
    </>
  )
}

export default DownloadFile